import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { fetchSurveyScore, updateSurveyScore } from "../../actions/surveyScore";

import "./SurveyScore.scss";
import SurveyScoreForm from "../Forms/SurveyScore";
import { DateTimeFormat } from "../../helpers/utils";
import { ReactSVG } from "react-svg";
import { Link } from "react-router-dom";

const SurveyScorePage = () => {
	const { id } = useParams();
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [surveyScoreId, setSurveyScoreId] = useState(null);
	const { status, surveyScore } = useSelector(
		(state) => state.fetchSurveyScore,
	);
	const { status: updateStatus } = useSelector(
		(state) => state.updateSurveyScore,
	);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleEdit = () => {
		showModal();
		setSurveyScoreId(surveyScore.id);
		const newRecord = { ...surveyScore };
		const newProductIds = newRecord.product_ids
			? newRecord.product_ids.ids
			: null;
		const productDescription = newRecord.product_ids
			? newRecord.product_ids.description
			: null;
		const productStatus = newRecord.product_ids
			? newRecord.product_ids.status
			: null;
		const productRecommendation = newRecord.product_ids
			? newRecord.product_ids.recommendation
			: null;
		newRecord.product_ids = newProductIds;
		newRecord.product_description = productDescription;
		newRecord.product_status = productStatus;
		newRecord.product_recommendation = productRecommendation;
		form.setFieldsValue(newRecord);
	};

	const handleSubmitForm = (values) => {
		const newValues = { ...values };
		const newProduct = {
			ids: values.product_ids,
			description: values.product_description,
			status: values.product_status,
			recommendation: values.product_recommendation,
		};
		newValues.product_ids = values.product_ids ? newProduct : null;
		delete newValues.product_description;
		delete newValues.product_status;
		delete newValues.product_recommendation;
		delete newValues.product_description;
		dispatch(updateSurveyScore(surveyScoreId, newValues));
		handleOk();
	};

	useEffect(() => {
		if (status === "IDLE") {
			dispatch(fetchSurveyScore(id));
		}
	}, [status]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED") dispatch(fetchSurveyScore(id));
	}, [updateStatus]);

	return (
		<div id="survey-score-container">
			<div className="page-header">
				<h2 className="page-header-title">Survey Score Details</h2>
			</div>
			<div className="page-header-details-actions">
				<Link to="/survey-scores">
					<Button type="link" className="btn btn-back">
						<ReactSVG src="/icons/arrow-left.svg" />
						Back
					</Button>
				</Link>
				<Button
					type="primary"
					className="btn-primary"
					onClick={() => handleEdit()}
				>
					Edit
					<ReactSVG src="/icons/edit.svg" />
				</Button>
			</div>
			{status === "SUCCEEDED" && (
				<div className="page-content">
					<div className="page-details-section">
						<div>
							<div className="box">
								<div className="box-header">
									<h2 className="box-title">Details</h2>
								</div>
								<div className="box-content">
									<div className="details-item">
										<label>Survey Category</label>
										<div className="text">{surveyScore.survey_category_id}</div>
									</div>
									<div className="details-item">
										<label>Score Start</label>
										<div className="text">{surveyScore.score_start}</div>
									</div>
									<div className="details-item">
										<label>Score End</label>
										<div className="text">{surveyScore.score_end}</div>
									</div>
									{surveyScore.product_ids && (
										<Fragment>
											<div className="details-item">
												<label>Product IDs</label>
												<div className="text">
													{surveyScore.product_ids.ids.join(", ")}
												</div>
											</div>
											<div className="details-item">
												<label>Product Description</label>
												<div className="text">
													{surveyScore.product_ids.description}
												</div>
											</div>
											<div className="details-item">
												<label>Product Status</label>
												<div className="text">
													{surveyScore.product_ids.status}
												</div>
											</div>
											<div className="details-item">
												<label>Recommendation</label>
												<div className="text">
													{surveyScore.product_ids.recommendation}
												</div>
											</div>
										</Fragment>
									)}
									<div className="details-item">
										<label>Updated At</label>
										<div className="text">
											{DateTimeFormat(surveyScore.updated_at)}
										</div>
									</div>
									<div className="details-item">
										<label>Created At</label>
										<div className="text">
											{DateTimeFormat(surveyScore.created_at)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			<Modal
				className="add-category-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<SurveyScoreForm
					form={form}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
				/>
			</Modal>
		</div>
	);
};

export default SurveyScorePage;
